import { useMemo } from 'react';
import { useLocation } from 'react-router-dom';

import { FEATURES } from 'appConstants';
import { useFeatureFlags } from 'hooks';

import useOrbitAccess from '../useOrbitAccess';
import { readOrbitL4DevOverride } from './devFlagOverride';

/**
 * The one switch for every Layer 4 surface. Orbit access already folds in `ai_assistant`, the
 * `perx_ai_workspace` master and the `use` grant, so the actions flag only narrows it further.
 */
const useOrbitLayer4 = (): boolean => {
  const access = useOrbitAccess();
  const flags = useFeatureFlags();
  const { search } = useLocation();
  const devOverride = useMemo(() => readOrbitL4DevOverride(search), [search]);

  return access === 'allowed' && (flags[FEATURES.ORBIT_LAYER_4.key] === true || devOverride);
};

export default useOrbitLayer4;
